import Link from 'next/link';

import { Lia } from 'src/components/ui/Lia';
import { Text } from 'src/components/ui/Text';
import { Title } from 'src/components/ui/Title';

const PrivacyPolicy = () => {
  return (
    <div className="mx-auto max-w-2xl p-5 sm:px-0 sm:py-20">
      <Lia />

      <Title
        size="xl"
        className="my-10"
      >
        Política de privacidade
      </Title>

      <Title>Introdução</Title>
      <Text className="mb-6 mt-4">
        Para a utilização de nossos serviços e produtos pode ser necessário que realizemos o tratamento de alguns de
        seus dados pessoais durante o processo, portanto, apresentamos desde já o nosso compromisso com a proteção e
        tratamento seguro destes dados que, aliados à política de cookies e dos termos de uso (também presentes em nosso
        site), caracterizam nossas políticas e o quanto nos comprometemos com a proteção e segurança dos nossos Clientes
        e/ou Usuários.
        <br />
        <br />
        A proteção de dados e a privacidade são pilares no desenvolvimento de nossos serviços, estamos em constante
        aprimoramento para atendermos todas as disposições da Lei Geral de Proteção de Dados Pessoais (LGPD - Lei n.º
        13.709/2018) e demais orientações e normativas de leis de privacidade e autoridades acerca do tema, sempre que
        aplicável.
        <br />
        <br />
        Destacamos que prestamos amplo apoio aos direitos de liberdade, igualdade, transparência e privacidade,
        garantindo aos nossos clientes, o cumprimento de quaisquer dos direitos previstos na LGPD, conforme disposto em
        nossa Política de Privacidade onde você poderá encontrar também detalhes sobre os seus dados. Usuário, tenha
        ciência que é vedado o fornecimento de dados que não sejam seus, tendo em vista que apenas o próprio titular
        pode dispor ou autorizar a utilização de seus dados, através de checkbox.
        <br />
        <br />
        Em caso de qualquer dúvida em relação a este Aviso, à Política de Privacidade ou ao tratamento de dados
        pessoais, você poderá entrar em contato conosco por meio dos seguintes canais de atendimento:{' '}
        <Link
          href="mailto:privacidade@lia.com.br"
          target="_blank"
          className="underline"
        >
          privacidade@lia.com.br
        </Link>
        <br />
        <br />
        Fique à vontade para interagir diretamente com o nosso Encarregado de Dados através dos canais aqui
        disponibilizados, nos termos previstos na Política de Privacidade.
      </Text>

      <Title>Definições</Title>
      <Text
        className="mb-6 mt-4"
        as="div"
      >
        Dados Pessoais ou simplesmente “Dados”: toda informação do Cliente/Usuário que permita sua identificação, ainda
        que seja necessária sua combinação com outras informações, ou que possam ser a estes relacionadas, as quais
        serão objeto de tratamento.
        <br />
        <br />
        Cliente/Usuário: todas as pessoas físicas e/ou jurídicas que sejam usuários da LIA, incluindo aqueles que
        acessem, naveguem pelo e/ou utilizem a Plataforma e os serviços disponíveis.
        <br />
        <br />
        Finalidade/Necessidade: motivo pelo qual são coletados e tratados os Dados Pessoais indispensáveis ao alcance de
        tal objetivo.
        <br />
        <br />
        Plataforma: qualquer via de acesso às facilidades da empresa, como o site, aplicativo e assistentes virtuais de
        propriedade da LIA.
        <br />
        <br />
        Autoridade Nacional de Proteção de Dados - ANPD: órgão da administração pública responsável por zelar,
        implementar e fiscalizar o cumprimento da LGPD.
        <br />
        <br />
        Pelos Canais de Atendimento, o Usuário (se pessoa física) também poderá requerer:
        <br />
        <ol className="list-inside list-[lower-roman] pl-4">
          <li>A limitação do uso de seus Dados Pessoais;</li>
          <li>Manifestar sua oposição e/ou revogar o consentimento quanto ao uso de seus Dados Pessoais; ou</li>
          <li>Solicitar a exclusão de seus Dados Pessoais que tenham sido coletados pela LIA.</li>
        </ol>
      </Text>

      <Title>Do propósito da política de privacidade</Title>
      <Text className="mb-6 mt-4">
        A presente Política de Privacidade (“Política”) tem por finalidade demonstrar o compromisso da:
        <br />
        <br />
        <strong>LIA TECNOLOGIA E SERVIÇOS LTDA.(“LIA”)</strong>, pessoa jurídica de direito privado, constituída sob a
        forma de sociedade empresária limitada, inscrita no CNPJ sob o nº 44.432.290/0001-18, com sede na Avenida
        Paulista, nº 777, sala 102, Bela Vista, São Paulo/SP, CEP 01311-914, denominada simplesmente por “LIA” neste
        documento. Todos os direitos reservados.
        <br />
        <br />
        A Plataforma LIA é acessada através da internet, pelo site: www.lia.com.br e app, seus subdomínios, e também
        através de conexão direta, via network socket e/ou API (Interface de Programação de Aplicações) própria (quando
        aplicável), onde são oferecidos os serviços adquiridos, mediante contratação.
        <br />
        <br />
        Com a privacidade e a proteção das informações recebidas de seus clientes, inclusive Dados Pessoais, além de
        estabelecer as regras sobre o tratamento de tais dados, visamos a transparência, dentro do escopo dos serviços e
        funcionalidades de nossa plataforma, sempre de acordo com as leis em vigor, com a clareza necessária junto ao
        Usuário e ao mercado.
        <br />
        <br />
        <strong>
          Por favor, leia esta política cuidadosamente antes de utilizar nossos ambientes. Ao navegar ou utilizar nossas
          soluções, qualquer seja a forma, você (&quot;Usuário&quot;) reconhece ter lido, entendido e concordado com
          todos os termos e condições aqui estabelecidos, obrigando-se automaticamente às cláusulas aqui aplicáveis e
          conferindo a sua livre e expressa concordância com as condições abaixo especificadas.
        </strong>
        <br />
        <br />
        Em complemento ao disposto acima, o propósito desta Política de Privacidade é descrever os tipos de informação
        que podemos coletar, quando você visita nosso site, ou utiliza nossa plataforma através de algum meio, bem como
        explicar como utilizamos essas informações.
        <br />
        <br />
        Ao concordar, saiba que podemos utilizar seus dados tão somente para processar suas solicitações, efetuar
        sugestões de interesse, incluindo e-mails marketing e relativos a assuntos que achamos ter relevância para você;
        também podemos utilizar seus dados para fazer contato futuro, através de qualquer meio (sempre de acordo com a
        Política de Privacidade), sendo primordial o aceite aos termos.
        <br />
        <br />
        Qualquer informação sobre si que você optar por fornecer através de nossa Plataforma, será mantida de forma
        segura. Visamos garantir que os seus dados armazenados sejam precisos, relevantes e não excessivos. Manteremos
        esses dados atualizados e não reteremos qualquer informação por mais tempo que o necessário. Manteremos os dados
        de forma segura, para prevenir o acesso não autorizado de terceiros. Você terá o direito de ver o que está sendo
        armazenado sobre você e poderá corrigir quaisquer erros.
        <br />
        <br />
        O envio de e-mails será feito apenas com o seu consentimento no momento de finalização de seu cadastro e poderá
        ser desativado a qualquer momento. A LIA é contra o envio de e-mails sem autorização prévia (conhecidos como
        SPAM). Ao se cadastrar em nossa Plataforma, o Usuário dará anuência ao recebimento de e-mails com informações
        importantes e sobre os serviços.
        <br />
        <br />
        <strong>
          A LIA fará o compartilhamento dos dados do cliente para analisar sua saúde financeira, junto a agentes de
          crédito. O Usuário concorda com o compartilhamento de seus dados, sempre que necessário para a finalização da
          compra efetuada.
        </strong>
        <br />
        <br />
        A LIA também se reserva ao direito de modificar a presente Política de Privacidade a qualquer tempo, mantendo-a
        atualizada e disponível em seu site, sendo recomendável a leitura periódica e integral da presente Política de
        Privacidade.
        <br />
        <br />
        <strong>IMPORTANTE:</strong> NOSSOS AMBIENTES SÃO DIRECIONADOS PARA UTILIZAÇÃO APENAS DE USUÁRIOS MAIORES DE 18
        (DEZOITO) ANOS, SENDO VEDADO O CADASTRO DE CRIANÇAS E/OU ADOLESCENTES.
      </Text>

      <Title>Dos dados coletados</Title>
      <Text
        className="mb-6 mt-4"
        as="div"
      >
        <strong>Dados cadastrais</strong>
        <div className="mt-4 grid grid-cols-3 gap-x-4 bg-background-least p-4">
          <Text
            weight="bold"
            className="col-span-1"
          >
            O que podemos coletar?
          </Text>
          <Text
            weight="bold"
            className="col-span-2"
          >
            Para que se coleta?
          </Text>
        </div>
        <div className="mb-4 grid grid-cols-3 items-center gap-x-4 bg-background-subtle p-4">
          <div className="col-span-1">
            Nome completo/ Razão Social do usuário
            <br />
            Número do CPF/ CNPJ
            <br />
            Telefone de contato/Celular
            <br />
            Endereço
            <br />
            E-mail
            <br />
            Data de nascimento
            <br />
            Dados Financeiros
          </div>
          <div className="col-span-2">
            <ol className="list-inside list-[lower-roman] pl-4">
              <li>Identificar e autenticar o Usuário da Plataforma.</li>
              <li>Possibilitar a confirmação da utilização serviço, gerar e efetuar cobranças.</li>
              <li>
                Ampliar nosso relacionamento, informar o Usuário sobre novidades, funcionalidades, conteúdos, notícias e
                demais eventos que consideramos relevantes.
              </li>
              <li>
                Cumprir com as obrigações legais de manutenção de registros estabelecidas pelo Marco Civil da Internet -
                Lei 12.965/2014 e LGPD.
              </li>
              <li>Permitir a portabilidade para outro Controlador caso o Usuário deseje.</li>
              <li>
                Obter informações acerca do que é produzido pelo usuário ou assuntos pessoais de seu interesse, para um
                melhor gerenciamento de sua conta dentro da aplicação.
              </li>
              <li>
                Assertividade e segurança no acesso: manter suas informações cadastrais corretas e atualizadas,
                permitindo a verificação e confirmação da sua identidade, a prevenção de fraude, bem como evitar o
                contato de contatos indevidos.
              </li>
              <li>Relacionamento do cliente com o Usuário.</li>
              <li>Envio de Newsletter.</li>
            </ol>
          </div>
        </div>

        <strong>Dados de identificação digital</strong>
        <div className="mt-4 grid grid-cols-3 gap-x-4 bg-background-least p-4">
          <Text
            weight="bold"
            className="col-span-1"
          >
            O que podemos coletar?
          </Text>
          <Text
            weight="bold"
            className="col-span-2"
          >
            Para que se coleta?
          </Text>
        </div>
        <div className="mb-4 grid grid-cols-3 items-center gap-x-4 bg-background-subtle p-4">
          <div className="col-span-1">
            Endereço IP e Porta Lógica de Origem;
            <br />
            Cookies;
            <br />
            Telas acessadas pelo usuário;
            <br />
            Geolocalização;
            <br />
            Dispositivo;
          </div>
          <div className="col-span-2">
            <ol className="list-inside list-[lower-roman] pl-4">
              <li>
                Cumprir com as obrigações legais de manutenção de registros estabelecidas pelo Marco Civil da Internet -
                Lei 12.965/2014;
              </li>
              <li>Monitoramento de segurança dos Nossos Ambientes em prol da sua e da nossa segurança.</li>
            </ol>
          </div>
        </div>
      </Text>

      <Title>Da política de cookies</Title>
      <Text className="mb-6 mt-4">
        O uso de cookies é feito apenas para reconhecer um visitante constante e aprimorar a experiência de
        relacionamento com o usuário. Os cookies são pequenos arquivos de dados transferidos de um site da web para a
        memória do seu computador/celular e não armazenam Dados Pessoais em si. Durante todo este procedimento mantemos
        suas informações em sigilo absoluto. Vale lembrar que seus dados são registrados de forma automática,
        dispensando manipulação humana.
        <br />
        <br />
        Para mais informações sobre quais cookies utilizamos e detalhes sobre as funcionalidades e prazo de
        armazenamento de cada um destes, consulte nossa{' '}
        <Link
          href="/politica-de-cookies"
          target="_blank"
          className="underline"
        >
          Política de Cookies
        </Link>
        .
      </Text>

      <Title>Dos meios de coleta de dados</Title>
      <Text
        className="mb-6 mt-4"
        as="div"
      >
        Nós poderemos coletar seus dados pessoais, em um primeiro momento, através de formulário de cadastro na
        plataforma ou também através do envio, pelo próprio Usuário, de informações através dos canais oficiais de
        contato, como o e-mail e o setor de atendimento ao consumidor, além do campo de entrada (login) na home do
        website ou aplicativo. Podemos, também, coletar seus dados através de cookies. Esses dados podem incluir
        informações como seu nome, endereço de e-mail e telefone.
        <br />
        <br />
        Usamos esses dados para:
        <br />
        <br />
        <ol className="list-inside list-[numeric] pl-4">
          <li>Ajudar a tornar seu acesso mais fluido;</li>
          <li>Enviar informações relevantes sobre produtos e serviços;</li>
          <li>Permitir seu acesso à Plataforma de um modo prático e rápido;</li>
          <li>Enviar e-mails esporádicos com conteúdo ou produtos/serviços que julguemos ser de seu interesse;</li>
          <li>Responder eventuais dúvidas que você tenha sobre nossos produtos e serviços;</li>
          <li>Análise e envio de sugestões.</li>
        </ol>
        <br />
        <br />
        Caso escolha não receber informações ou outros comunicados de nossa parte, você pode optar por se descadastrar
        através do e-mail recebido ou entrar em contato conosco pelo e-mail privacidade@lia.com.br
        <br />
        <br />
        Seu e-mail é utilizado exclusivamente com o propósito de comunicação, desde que o Usuário tenha dado seu prévio
        consentimento, conforme detalhado acima.
        <br />
        <br />A prestação dos Serviços e o uso das funcionalidades da Plataforma,
        <strong>
          dependem diretamente de alguns Dados informados na tabela acima, principalmente dos Dados cadastrais.
        </strong>{' '}
        Caso o Usuário opte por não fornecer alguns desses Dados, poderá ficar impossibilitado de usufruir totalmente
        dos Serviços oferecidos a ele.
        <br />
        <br />A LGPD resguarda os seus direitos enquanto titular dos seus Dados Pessoais, e, portanto, você poderá, a
        qualquer tempo, requerer:
        <br />
        <br />
        <ol className="list-inside list-[numeric] pl-4">
          <li>A confirmação da existência de tratamento e acesso aos seus Dados Pessoais;</li>
          <li>Correção de Dados Pessoais incompletos, inexatos ou desatualizados;</li>
          <li>
            Anonimização, bloqueio ou eliminação de dados desnecessários, comprovadamente excessivos ou tratados em
            desconformidade com a LGPD;
          </li>
          <li>
            Revogação do consentimento se este eventualmente constituir única Base Legal para alguma das Atividades de
            Tratamento e eliminação de tais dados;
          </li>
          <li>
            Oposição às Atividades de Tratamento fundamentadas em Hipótese de Tratamento diversa do consentimento em
            caso de descumprimento da LGPD, resguardada a recusa devidamente fundamentada pela LIA a tal solicitação;
          </li>
        </ol>
        <br />
        <br />
        Ressaltamos, ainda, que mesmo que você nos solicite a anonimização, bloqueio, eliminação ou oposição,
        eventualmente poderemos manter armazenados ou continuar o tratamento de alguns Dados Pessoais (i) para
        cumprimento de obrigação legal ou regulatória, (ii) resguardar e exercer direitos da LIA, inclusive aqueles
        relativos a processo judicial, administrativo ou arbitral, e (iii) para prevenção de ato ilícitos, (iv) evitar
        contatos indevidos, entre outros.
      </Text>

      <Title>Do armazenamento</Title>
      <Text className="mb-6 mt-4">
        Os Dados Pessoais coletados e os registros de atividades são armazenados em ambiente seguro e controlado por um
        prazo mínimo que segue a tabela abaixo:
        <br />
        <br />
        <u>Prazos de armazenamento:</u>
        <br />
        <br />
        <strong>Dados cadastrais:</strong>
        <br />
        Prazo mínimo de 5 anos após o término da relação - Art. 12 e 34 do Código de Defesa do Consumidor;
        <br />
        <br />
        <strong>Dados de identificação cadastral:</strong>
        <br />
        Prazo mínimo de seis meses - Art. 15 do Marco Civil da Internet;
        <br />
        <br />
        <strong>Outros dados:</strong>
        <br />
        Enquanto durar a relação e não houver pedido para apagar ou até a revogação de consentimento - Art. 9, Inciso II
        da Lei Geral de Proteção de Dados Pessoais.
        <br />
        <br />
        Para fins de auditoria, segurança, controle de fraudes, proteção ao crédito e preservação de direitos, a LIA
        poderá permanecer com o histórico de registro de seus dados por prazo maior, nas hipóteses que a lei ou norma
        regulatória assim estabelecer.
        <br />
        <br />
        Os Dados coletados serão armazenados em servidores localizados no Brasil, bem como em ambiente de uso de
        recursos ou servidores na nuvem (cloud computing), o que poderá exigir uma transferência e/ou processamento
        destes Dados para parceiros, fora do Brasil. Sendo assim, o Usuário detém total ciência desta situação,
        concordando com os supracitados termos.
      </Text>

      <Title>Dos links externos</Title>
      <Text className="mb-6 mt-4">
        A Plataforma LIA poderá oferecer acesso a links de outros sites cujos conteúdos e políticas de privacidade não
        são de nossa responsabilidade. Assim, recomendamos que, ao ser redirecionado para sites externos, você consulte
        sempre as respectivas políticas de privacidade antes de fornecer seus dados ou informações.
        <br />
        <br />
        É muito importante que o Usuário proteja seus Dados contra acesso não autorizado ao seu computador e Smartphone,
        além de se certificar de sempre clicar em “sair” ao encerrar sua navegação em um dispositivo compartilhado.
        Também é muito importante que o Usuário saiba que não serão enviadas pela LIA qualquer tipo de mensagens
        eletrônicas solicitando confirmação de dados ou com anexos que possam ser executados (extensões: .exe, .com,
        entre outros) ou ainda links para eventuais downloads.
        <br />
        <br />
        Caso empresas terceiras, que tenham parceria conosco, realizem o tratamento em nosso nome, de quaisquer Dados
        Pessoais que são coletados, elas respeitarão as condições aqui estipuladas e as normas de segurança da
        informação, obrigatoriamente.
      </Text>

      <Title>Dos deveres do usuário</Title>
      <Text className="mb-6 mt-4">
        Ao fornecer dados pessoais através de nosso website, você garante a veracidade e a exatidão desses dados,
        assumindo a correspondente responsabilidade caso não sejam exatos. A LIA não assume qualquer responsabilidade em
        caso de inexatidão dos dados pessoais introduzidos pelo usuário neste website.
        <br />
        <br />
        O Usuário concorda em não utilizar os serviços disponibilizados em nossa Plataforma para efetuar, solicitar,
        favorecer ou incentivar qualquer negócio ou atividade proibida por lei. A LIA reserva-se o direito de proibir as
        condutas, comunicações ou conteúdos que considere, a seu exclusivo e absoluto julgamento, violar qualquer lei ou
        que seja nociva aos Usuários individuais, a empresas e/ou terceiros/parceiros, sem que isto seja transformado em
        uma obrigação da LIA em monitorar toda a comunicação feita por meio da Plataforma.
        <br />
        <br />
        Se o Usuário retirar seu consentimento para finalidades fundamentais ao regular o funcionamento dos Serviços da
        Plataforma, tais ambientes e serviços poderão ficar indisponíveis para este Usuário, estando ciente que não há
        qualquer obrigação à LIA em manter todos os ambientes e serviços, se não tiver acesso aos dados, posto que
        interfere, tal conduta, diametralmente à natureza do negócio.
        <br />
        <br />
        Findo o prazo de manutenção e a necessidade legal, os Dados Pessoais serão excluídos com uso de métodos de
        descarte seguro de dados, ou utilizados de forma anonimizada para fins estatísticos.
      </Text>

      <Title>Disposições gerais</Title>
      <Text className="mb-6 mt-4">
        O Usuário declara, reconhece e aceita que: (a) o estágio atual da técnica não permite a elaboração de programas
        de computador totalmente isentos de defeitos e que, assim sendo, a LIA não pode garantir que o Site operará
        ininterruptamente ou livre de vícios ou defeitos; (b) o Site é desenvolvido sob encomenda ao Usuário, mas para
        uso genérico, razão pela qual a LIA não pode garantir que este atenderá quaisquer necessidades específicas de
        cada Usuário; e (c) a Internet é uma rede mundial de computadores, à qual qualquer pessoa pode ter acesso e, por
        tal razão, não é um ambiente totalmente seguro de comunicação. A LIA não se responsabilizará, em nenhuma
        hipótese, perante ao Usuário ou a terceiros, por prejuízos de qualquer espécie, inclusive, mas sem limitação,
        àqueles decorrentes de divulgação de informações a terceiros, inexatidão no preenchimento de dados ou extravio
        de dados decorrentes direta ou indiretamente do mau uso da Internet, pelo Usuário.
        <br />
        <br />
        O Usuário concorda ainda, em isentar a LIA de qualquer responsabilidade por danos resultantes do uso indevido da
        Plataforma, pelo Usuário e/ou quaisquer terceiros, que resultem na inclusão de dados falsos ou incorretos,
        cadastros efetuados sem o consentimento do titular, qualquer tipo de modificação ou quaisquer outras condutas
        e/ou condições não controladas pela LIA.
        <br />
        <br />
        Esta Política está sujeita a constante melhoria e aprimoramento. A LIA se reserva ao direito de modificá-la a
        qualquer momento, conforme a finalidade ou necessidade, tal qual para adequação e conformidade legal de
        disposição de lei ou norma que tenha força jurídica equivalente, cabendo ao Usuário verificá-la sempre que
        efetuar o acesso à Plataforma, por qualquer meio disponível.
        <br />
        <br />
        Ocorrendo atualizações neste documento e que eventualmente demandem coleta de consentimento, o Usuário será
        notificado por meio dos canais de contatos que nos informou no momento do cadastro. Na hipótese de qualquer
        cláusula, termo ou disposição desta Política ser declarada nula, tal nulidade não afetará quaisquer outras
        cláusulas, em relação às disposições aqui contidas, as quais deverão permanecer em pleno vigor e efeito.
        <br />
        <br />
        A tolerância, pela LIA, com relação a qualquer violação da Política ou sua omissão no exercício de qualquer
        direito outorgado pela mesma, não será considerada como novação ou renúncia em relação a violação futura, seja
        semelhante ou não, ou ao exercício, pela LIA, de qualquer direito futuro conferido por este instrumento.
        <br />
        <br />
        O Usuário, seja pessoa jurídica ou física, reconhece que toda comunicação realizada por e-mail (aos endereços
        informados no seu cadastro), SMS, aplicativos de comunicação instantânea, telefone ou qualquer outra forma
        digital, também são válidas, eficazes e suficientes para a divulgação de qualquer assunto que se refira aos
        Serviços, aos seus Dados, bem como às condições da prestação de serviços e recebimentos, ou a qualquer outro
        assunto nele abordado, sendo exceção apenas o que essa Política prever como tal.
        <br />
        <br />
        Os presentes termos e condições serão regidos pela legislação brasileira e qualquer controvérsia que possa
        surgir dos serviços de acesso disponibilizados pela LIA ao Usuário será submetida ao Foro da Capital do Estado
        de São Paulo, com renúncia expressa a qualquer outro foro.
        <br />
        <br />
        Caso reste qualquer dúvida, por favor contate nossos Canais de Atendimento, descritos ao início desse documento.
      </Text>

      <Title>Das dúvidas</Title>
      <Text className="mt-4">
        Caso tenha quaisquer perguntas específicas que não tenham sido cobertas por este documento, ou se você quiser
        saber exatamente quais as informações que temos sobre você, por favor entre em contato via e-mail{' '}
        <Link
          href="mailto:privacidade@lia.com.br"
          target="_blank"
          className="underline"
        >
          privacidade@lia.com.br
        </Link>
        .
      </Text>

      <footer className="mt-10 flex flex-col items-center justify-center gap-4 text-center sm:flex-row">
        <Link
          href="/politica-de-privacidade"
          className="text-foreground-subtle underline hover:text-foreground-main"
        >
          Política de privacidade
        </Link>
        <Link
          href="/politica-de-cookies"
          className="text-foreground-subtle underline hover:text-foreground-main"
        >
          Política de cookies
        </Link>
        <Link
          href="/termos-de-uso"
          className="text-foreground-subtle underline hover:text-foreground-main"
        >
          Termos de uso
        </Link>

        <Link
          href="/termos-de-contrato"
          className="text-foreground-subtle underline hover:text-foreground-main"
        >
          Termos de Contrato
        </Link>
      </footer>
    </div>
  );
};

export default PrivacyPolicy;
